<div class="">
    <div class="side-menu-list">
        <ul class="menu-items-sidebar">
           <ng-container *ngIf="items?.length">
               <ng-container *ngIf="items[0] as firstItem">
                   <li
                       [class.onActive]="firstItem.contentId === selectedId"
                       [class.disabled]="firstItem.disabled"
                       [attr.aria-disabled]="firstItem.disabled ? true : null"
                       tabindex="{{0 === focusIndex ? 0 : -1}}"
                       (click)="!firstItem.disabled && select(firstItem,0)">
                       <mat-icon>{{firstItem.icon}}</mat-icon>
                       <span>{{firstItem.label}}</span>
                   </li>
                   <!-- If the first item is the account/group entry (acc), render remaining items as subsections -->
                   <ng-container *ngIf="firstItem?.contentId === 'acc'">
                       <ul class="submenu">
                           <li *ngFor="let item of items | slice:1; let i = index"
                                   class="submenu-item"
                [class.onActive]="item.contentId === selectedId"
                [class.disabled]="item.disabled"
                [attr.aria-disabled]="item.disabled ? true : null"
                                   tabindex="{{(i+1) === focusIndex ? 0 : -1}}"
                                   (click)="!item.disabled && select(item,i+1)">
                <mat-icon>{{item.icon}}</mat-icon>
                <span>{{item.label}}</span>
            </li>
                       </ul>
                   </ng-container>
                   <!-- Fallback: if first item is not a grouping entry, render the rest as normal top-level items -->
                   <ng-container *ngIf="firstItem?.contentId !== 'acc'">
                       <li *ngFor="let item of items | slice:1; let i = index"
                               [class.onActive]="item.contentId === selectedId"
                               [class.disabled]="item.disabled"
                               [attr.aria-disabled]="item.disabled ? true : null"
                               tabindex="{{(i+1) === focusIndex ? 0 : -1}}"
                               (click)="!item.disabled && select(item,i+1)">
                           <mat-icon>{{item.icon}}</mat-icon>
                           <span>{{item.label}}</span>
                       </li>
                   </ng-container>
               </ng-container>
           </ng-container>
        </ul>
    </div>
</div>